import { useFormStore } from '@/stores/form'
import { useAuthStore } from '@/stores/auth'
import apiHelperService from '@/services'
import router from '@/router'
import { useGlobalStore } from '@/stores/global'
import lookups from '@/assets/json/clientLookups.json'

const initForm = async () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  const { administrativeRegionId = '', withException = '' } = router.currentRoute.value.query
  formStore.extraMap = {
    ...formStore.extraMap,
    isConcernedEstablishmentAvailable: false,
    isEstablishmentCanBeGroup: false,
    isConcernedEstablishmentRequired: false,
    isConcernedPersonAvailable: true,
    isPersonCanBeGroup: true,
    isConcernedPersonRequired: false,
    administrativeRegionId: null,
    serviceTransactionId,
    administrativeRegionId,
    withException: withException == 'true'
  }
  formStore.draft.request = {
    ...formStore.draft.request,
    isUsingCardReader: true
  }
}

const fetchInfo = async () => {
  return await apiHelperService.get(`/api/individual/info`)
}
const initInfo = async () => {
  const formStore = useFormStore()
  const authStore = useAuthStore()
  if (authStore.user.applicationId == 2) {
    formStore.draft.request.establishmentRequestTypeId = 1
    return
  }
  const res = await fetchInfo()
  const { nationality, identityNumber, unifiedNumber, englishFullName, arabicFullName } = res

  formStore.form.setValues({
    identityNumber: identityNumber,
    unifiedNumber: unifiedNumber,
    englishApplicantName: englishFullName,
    arabicApplicantName: arabicFullName,
    investorUnifiedNumber: unifiedNumber,
    'nationality.text': nationality.text
  })
}

export default async function () {
  try {
    await initForm()
    await initInfo()
  } catch (error) {
    console.error('use148Preload', error)
  }
}
